// extracted by mini-css-extract-plugin
export default {"title":"cwci8___Header-module__title"};